export function AboutPage() {
  return (
    <div className="about-page grid-twelve-cols-lg grid-four-cols-sm">
      <a
        href="mailto:deine.mail@domain.com"
        className="start-four-lg span-three-lg start-three-md span-four-md start-one-sm span-four-sm bcard"
      >
        <img
          className="bcard"
          src="/assets/bcardfront.webp"
          alt="business card front"
        />
      </a>
      <a
        href="mailto:hello@giannaricci-design.com"
        className="start-seven-lg span-three-lg start-seven-md span-four-md start-one-sm span-four-sm"
      >
        <img
          className="bcard"
          src="./assets/bcardback.webp"
          alt="business card back"
        />
      </a>
      <p className="introduction start-one-lg span-twelve-lg start-one-sm span-four-sm break-text">
        I’m a communication designer working with typography and editorial
        structures to explore how content is shaped, weighted, and perceived. I
        understand design as a tool for conveying attitude, structure, and
        meaning beyond literal content. My work explores how layout, rhythm, and
        spatial tension influence perception, using typography not only to
        convey information but to shape reading, orientation, and emphasis. Form
        is derived from content rather than predefined standards, balancing
        functional clarity with expressive precision.
      </p>
    </div>
  );
}
